/* Her Part first-party analytics helpers (tracking fixes F6/F7, 2026-10-17).
 * Our own script: it never edits Whop's her-part-tracking.js; it only calls window.hpTrack (that script's send()).
 * - F6: remembers the external referrer of the session's first page in hp_ref (the checkout Worker reads it);
 *       ?hp_qa=1 / ?hp_qa=0 sets/clears the QA cookie (test traffic is flagged server-side).
 * - F7: page_exit {page_view_id, engaged_ms (visible time only), max_scroll_pct} on visibilitychange→hidden and pagehide;
 *       one page_engaged at 15 s visible; a bfcache restore (pageshow persisted) re-fires store_page_view.
 * - Landers: cta_click on any product / checkout / add-to-cart link or button (generic; new pages need no setup).
 */
(() => {
  const TAIL = "; Domain=.getherpart.com; Path=/; SameSite=Lax; Secure";
  const cookie = (n) => { const p = document.cookie.split("; ").find((x) => x.startsWith(n + "=")); try { return p ? decodeURIComponent(p.slice(n.length + 1)) : ""; } catch { return ""; } };
  const setCookie = (n, v, s) => { document.cookie = `${n}=${encodeURIComponent(v)}; Max-Age=${s}${TAIL}`; };
  const uuid = () => (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2));

  try {
    const qa = new URLSearchParams(location.search).get("hp_qa");
    if (qa === "1") setCookie("hp_qa", "1", 31536000);
    if (qa === "0") setCookie("hp_qa", "", 0);
  } catch { /* ignore */ }
  try {
    const ref = document.referrer ? new URL(document.referrer) : null;
    if (ref && !/(^|\.)getherpart\.com$/i.test(ref.hostname) && !cookie("hp_ref")) {
      setCookie("hp_ref", `${ref.protocol}//${ref.hostname}${ref.pathname}`.slice(0, 300), 1800);
    }
  } catch { /* ignore */ }

  // F10: hpTrack (her-part-tracking.js send()) silently drops events when hp_sid expired mid-page; for our own events
  // we re-create it (same 30-minute cookie that script sets) when consent is on.
  const ensureSession = () => {
    if (cookie("hp_sid") || (cookie("hp_analytics") !== "1" && cookie("hp_marketing") !== "1")) return;
    setCookie("hp_sid", uuid(), 1800);
  };
  const track = (name, detail) => { try { ensureSession(); window.hpTrack && window.hpTrack(name, detail); } catch { /* ignore */ } };
  let pv, engaged, visibleSince, maxScroll, seq, engagedSent;
  const reset = () => {
    pv = uuid(); engaged = 0; maxScroll = 0; seq = 0; engagedSent = false;
    visibleSince = document.visibilityState === "visible" ? performance.now() : null;
  };
  const engagedNow = () => engaged + (visibleSince != null ? performance.now() - visibleSince : 0);
  const scroll = () => {
    const h = Math.max(document.documentElement.scrollHeight - innerHeight, 1);
    maxScroll = Math.max(maxScroll, Math.min(100, Math.round((scrollY / h) * 100)));
  };
  const exit = (why) => {
    const ms = Math.round(engagedNow());
    seq += 1;
    track("page_exit", { page_view_id: pv, engaged_ms: ms, max_scroll_pct: maxScroll, seq, why, path: location.pathname });
  };
  reset();
  addEventListener("scroll", scroll, { passive: true });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      if (visibleSince != null) { engaged += performance.now() - visibleSince; visibleSince = null; }
      exit("hidden");
    } else if (visibleSince == null) visibleSince = performance.now();
  });
  addEventListener("pagehide", () => {
    if (visibleSince != null) { engaged += performance.now() - visibleSince; visibleSince = null; }
    exit("pagehide");
  });
  addEventListener("pageshow", (e) => {
    if (!e.persisted) return;
    reset();
    track("store_page_view", { page_type: document.body?.dataset?.template || location.pathname, bfcache: 1, page_view_id: pv });
  });
  // Landers (2026-10-18): generic CTA click, no per-page setup. Any link/button that heads to a product page (other than
  // the one we're on), to checkout (secure.getherpart.com) or submits an add-to-cart form -> first-party cta_click.
  // Passive capture listener: never prevents, delays or rewrites the click; Whop's own checkout_clicked is untouched.
  document.addEventListener("click", (e) => {
    try {
      const el = e.target && e.target.closest && e.target.closest('a[href], button, [role="button"], input[type="submit"]');
      if (!el) return;
      let to = "", kind = "";
      const href = el.tagName === "A" ? el.getAttribute("href") : "";
      if (href) {
        const u = new URL(href, location.href);
        if (/^secure\.getherpart\.com$/i.test(u.hostname)) { to = u.hostname + u.pathname; kind = "checkout"; }
        else if (/(^|\.)getherpart\.com$/i.test(u.hostname) || u.hostname === location.hostname) {
          const m = u.pathname.match(/\/products\/[^/?#]+/);
          if (m && m[0] !== (location.pathname.match(/\/products\/[^/?#]+/) || [""])[0]) { to = m[0]; kind = "product"; }
        }
      } else {
        const form = el.form || el.closest("form");
        if (form && /\/cart\/add/.test(form.getAttribute("action") || "")) { to = "/cart/add"; kind = "add_to_cart"; }
      }
      if (!to) return;
      track("cta_click", { to: to.slice(0, 200), kind, text: (el.innerText || el.value || "").trim().slice(0, 60), path: location.pathname, page_view_id: pv });
    } catch { /* ignore */ }
  }, { capture: true, passive: true });
  setInterval(() => {
    if (!engagedSent && engagedNow() >= 15000) { engagedSent = true; track("page_engaged", { page_view_id: pv, engaged_ms: Math.round(engagedNow()), path: location.pathname }); }
  }, 1000);
})();
